export const SERVICE_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published'
};
export const SERVICE_STATUSES_TITLES = {
  DRAFT: 'Черновик',
  PUBLISHED: 'Активно'
};
